import API from "../../../services/api";
import { 
  CredentialsLoginParam, 
  CredentialsLoginRequest, 
  CredentialsLoginResponse 
} from "../types/credentials";
import { EndpointsCredentials } from "./endpoints";

export const loginCredentials = ({user, password}: CredentialsLoginParam) => {
  return new Promise<CredentialsLoginResponse>(async (resolve, reject) => {
    API.post<CredentialsLoginResponse, CredentialsLoginRequest>({
      endpoint: EndpointsCredentials.LoginCredentials,
      data: { user, password }
    })
    .then(res => {
      resolve(res.promise.data);
    })
    .catch(err => {
      reject(err);
    })
  })
}

export default {
  loginCredentials
};